import { IconButton, TableCell } from '@mui/material'
import React from 'react'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'

const MyTableMoreIco = ({ open, setOpen }) => {
  return (
    <TableCell align='center'>
        <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
    </TableCell>
  )
}

export default MyTableMoreIco